export default function SignupErrorPage() {
    return (
        <>
            <div className="min-h-full pt-16 pb-12 flex flex-col bg-white">
                <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="py-16">
                        <div className="text-center">
                            <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide">error</p>
                            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">To many attempts</h1>
                            <p className="mt-2 text-base text-gray-500">Sorry, you will have to wait 24 hours before trying again</p>
                            <div className="mt-6">
                                <a href="https://secure.vault56.com" className="text-base font-medium text-indigo-600 hover:text-indigo-500">
                                    Go back to login page<span aria-hidden="true"> &rarr;</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </main>
                <footer className="flex-shrink-0 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                    <nav className="flex justify-center space-x-4">
                        <a href="https://vault56.com" className="text-sm font-medium text-gray-500 hover:text-gray-600">
                            vault56 web page (contact support)
                        </a>
                    </nav>
                </footer>
            </div>
        </>
    )
}
